import "./Footer.css"
export default function Footer() {
  return (
    <footer>
      This progect was coded by{" "}
      <a
        href="https://github.com/Liubov-Ukr"
        target="_blank"
        rel="noopener noreferrer"
      >
        Liubov Opryshchenko
      </a>{" "}
      and is{" "}
      <a
        href="https://github.com/Liubov-Ukr/dictionary-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        open-sourced on GitHub
      </a>{" "}
    </footer>
  );
}
